import * as React from 'react';
import {useDispatch} from 'react-redux';
import {Switch} from 'react-router-dom';

import {fetchSchemaAction} from '../forms/forms-actions';
// @ts-expect-error
import {fetchDashboardSchema} from '../master-dashboard/dashboard-actions';

import {SchedulerRoutes} from './routes';

export function SchedulerRoot() {
    const dispatch = useDispatch();
    // @ts-expect-error
    const fetchFormSchema = () => dispatch(fetchSchemaAction());
    const getDashboardSchema = () => dispatch(fetchDashboardSchema());

    React.useEffect(() => {
        fetchFormSchema();
        getDashboardSchema();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Switch>
            <SchedulerRoutes />
        </Switch>
    );
}
